import React, { useContext, useState } from 'react'
import { Box, Text } from '@usap/uicomponents'
import { BoxWithPointer } from '@usap/widgets'

import seoIDs from '../../../../../config/seoIds'

import { LocalContext } from '../../../../helpers/useLocalContext'

export default function ProductDetails(props) {
  const {
    productAttributes,
    index,
    sku,
  } = props

  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext

  const [moreDetails, showMoreDetails] = useState(false)
  const limit = isBot ? productAttributes.length : 3

  const hasProductAttributes = Boolean(productAttributes && productAttributes.length)
  const toogleButtonId = moreDetails ? `viewLessProductsDetails-${sku}-${index}` : `seeAllProductsDetails-${sku}-${index}`
  const toggleButtonLabel = moreDetails ? 'View Less': 'See All Products Details'

  return hasProductAttributes ? (
    <Box>
      <Text size="xsmall" weight="bold">
        Product Details
      </Text>

      <Box>
        <Box>
          {productAttributes.map(({ label, value }, pindex) => {
            if (pindex < limit || moreDetails) {
              return (
                <Text
                  key={label}
                  size="xsmall"
                  truncate
                  dangerouslySetInnerHTML={{
                    __html: `${label} : ${value}`,
                  }}
                />
              )
            }
            return ''
          })}
        </Box>

        {!isBot && productAttributes.length > limit && (
        <BoxWithPointer
          id={toogleButtonId}
          alignSelf="start"
          align="center"
          onClick={() => showMoreDetails(!moreDetails)}
        >
          <Text
            id={seoIDs.pdSeeAll.replace('{{key}}', index)}
            size="xsmall"
            color="#05629b"
          >
            {toggleButtonLabel}
          </Text>
        </BoxWithPointer>
        )}
      </Box>
    </Box>
  ) : ''
}
